import { instantsInterceptor, } from '@/api/index';



function getLanguages() {
    return instantsInterceptor.get('/service/code/languages');
}

function getModelCodeList(lang) {
    return instantsInterceptor.get('/mgmt/modelCode/list?lang=' + lang);
}

function fetchModelCodeForm() {
    return instantsInterceptor.get('/mgmt/modelCode/form');
}

function addModelCode(form) {
    return instantsInterceptor.post('/mgmt/modelCode/form', form);
}

function getModelCodeAndLabel(doctypeId) {
    return instantsInterceptor.get('/mgmt/modelCode/updateForm/' + doctypeId);
}

function update(form) {
    return instantsInterceptor.post('/mgmt/modelCode/update', form);
}

function updateModelCodeOrder(form) {
    return instantsInterceptor.post('/mgmt/modelCode/changeOrder', form);
}

function changeModelUse(form) {
    return instantsInterceptor.post('/mgmt/modelCode/changeUse', form);
}

function deleteModel(form) {
    return instantsInterceptor.post('/mgmt/modelCode/delete', form);
}

function checkModelNameDuplication(form) {
    return instantsInterceptor.post('/mgmt/modelCode/check', form);
}

export {
    getLanguages,
    checkModelNameDuplication,
    getModelCodeList,
    fetchModelCodeForm,
    addModelCode,
    getModelCodeAndLabel,
    update,
    updateModelCodeOrder,
    changeModelUse,
    deleteModel
};